export const EXTERNAL_OIDC_VAULT_CRM_SSO_STATE = 'externalOidcVaultCrmSsoState';
export const EXTERNAL_OIDC_VAULT_CRM_SSO_CODE_VERIFIER = 'externalOidcVaultCrmSsoCodeVerifier';
